<template>
  <div class="bolusCalculatorSettingTable_ctn" :style="style" :class="{ isLongLanguage }">
    <div v-show="!notFirstTable" class="bolusCalculatorSettingTable--twoColumn bolusCalculatorSettingTable_descriptionRow bolusCalculatorSettingTable_titleRow--top roundedCorner-t-l roundedCorner-t-r">      
      <div class="bolusCalculatorSettingTable_descriptionRow--label"> {{ $t('Active Insulin Time') }}</div>
      <div class="bolusCalculatorSettingTable_descriptionRow--content">{{ extra.effectiveTime }}</div>
    </div>
    <div v-show="!notFirstTable" class="bolusCalculatorSettingTable--twoColumn bolusCalculatorSettingTable_descriptionRow">      
      <div class="bolusCalculatorSettingTable_descriptionRow--label"> {{ $t('Reverse Correction') }}</div>
      <div class="bolusCalculatorSettingTable_descriptionRow--content">{{ extra.reverseCorrection !== undefined ? ($t((extra.reverseCorrection ? 'YES' : 'NO'))) : '' }}</div>
    </div>
    <div class="bolusCalculatorSettingTable_descriptionRow bolusCalculatorSettingTable_descriptionRow--columns" :class="{ 'bolusCalculatorSettingTable_titleRow--top': notFirstTable, 'roundedCorner-t-l': notFirstTable, 'roundedCorner-t-r': notFirstTable, 'roundedCorner-b-l': bgIsLastRow, 'roundedCorner-b-r': bgIsLastRow }" v-if="bgRowNums">
      <div class="bolusCalculatorSettingTable_descriptionRow--columnsOneColumn bolusCalculatorSettingTable_descriptionRow--rows">
        <div class="bolusCalculatorSettingTable_descriptionRow--rowsTitle">
          {{ $t('Target BG Value')}}{{ targetBgValueUnit ? ` [${targetBgValueUnit}]` : '' }}
        </div>
        <div class="bolusCalculatorSettingTable_descriptionRow--rowsCtn">
          <div class="bolusCalculatorSettingTable_descriptionRow--rowsCtnOneRow" v-for="v in bgRowNums" :key="`bolusCalculator_tbg_1_rows_${v}`">
            <div>{{ bgList[v - 1] ? bgList[v - 1]['column0'] : '' }}</div>
            <div>{{ bgList[v - 1] ? bgList[v - 1]['column1'] : '' }}</div>
          </div>          
        </div>
      </div>            
    </div>
    <div class="bolusCalculatorSettingTable_descriptionRow bolusCalculatorSettingTable_descriptionRow--columns" :class="{ 'bolusCalculatorSettingTable_titleRow--top': notFirstTable && !bgRowNums, 'roundedCorner-t-l': notFirstTable && !bgRowNums, 'roundedCorner-t-r': notFirstTable && !bgRowNums, 'roundedCorner-b-l': carboIsLastRow, 'roundedCorner-b-r': carboIsLastRow }" v-if="carboRowNums">
      <div class="bolusCalculatorSettingTable_descriptionRow--columnsOneColumn bolusCalculatorSettingTable_descriptionRow--rows">
        <div class="bolusCalculatorSettingTable_descriptionRow--rowsTitle">
          {{ $t('Carbohydrate Ratio')}} {{ carbohydrateRatioUnit ? `[${carbohydrateRatioUnit}]` : '' }}
        </div>
        <div class="bolusCalculatorSettingTable_descriptionRow--rowsCtn">
          <div class="bolusCalculatorSettingTable_descriptionRow--rowsCtnOneRow" v-for="v in carboRowNums" :key="`bolusCalculator_1_rows_${v}`">
            <div>{{ carboList[v - 1] ? carboList[v - 1]['column0'] : '' }}</div>
            <div>{{ carboList[v - 1] ? carboList[v - 1]['column1'] : '' }}</div>
          </div>
        </div>
      </div>            
    </div>
    <div class="bolusCalculatorSettingTable_descriptionRow bolusCalculatorSettingTable_descriptionRow--columns" :class="{ 'bolusCalculatorSettingTable_titleRow--top': notFirstTable && !bgRowNums && !carboRowNums, 'roundedCorner-t-l': notFirstTable && !bgRowNums && !carboRowNums, 'roundedCorner-t-r': notFirstTable && !bgRowNums && !carboRowNums, 'roundedCorner-b-l': sensitiveIsLastRow, 'roundedCorner-b-r': sensitiveIsLastRow }" v-if="sensitivityRowNums">
      <div class="bolusCalculatorSettingTable_descriptionRow--columnsOneColumn bolusCalculatorSettingTable_descriptionRow--rows">
        <div class="bolusCalculatorSettingTable_descriptionRow--rowsTitle">
          {{ $t('Insulin Sensitivity')}} {{ sensitivityUnit ? `[${sensitivityUnit}]` : '' }}
        </div>
        <div class="bolusCalculatorSettingTable_descriptionRow--rowsCtn">
          <div class="bolusCalculatorSettingTable_descriptionRow--rowsCtnOneRow" v-for="v in sensitivityRowNums" :key="`bolusCalculator_1_rows_${v}`">
            <div>{{ sensitivityList[v - 1] ? sensitivityList[v - 1]['column0'] : '' }}</div>
            <div>{{ sensitivityList[v - 1] ? sensitivityList[v - 1]['column1'] : '' }}</div>
          </div>                    
        </div>
      </div>            
    </div>    
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
const derror = derrorFactory('PumpTwoColumnTable.vue', true)
const error = errorFactory('PumpTwoColumnTable.vue', true)

let _id = 1
const _onePageRowNumMax = 20 // 修改这个数值后，需要更改Pump.vue的computed属性calculatorSettingPages里头的变量onePageMaxRowNums
const _carboNum = 8
const _targetBgNum = 1 // 两行
const _senNum = _onePageRowNumMax - _carboNum - _targetBgNum
export default {
  name: 'CPumpTwoColumnTable',
  mixins: [reDrawTrigger],
  components: {
  },
  props: {
    notFirstTable: {
      type: [Boolean, Number, String],
      default: false
    },
    extra: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    carboList: {
      type: [Array],
      default: () => []
    },
    carboRowNums: { // 总共可展现数据对: carboRowNums * 2 条
      type: [Number],
      default: 0
    },
    bgRowNums: {
      type: [Number],
      default: 0
    },
    bgList: {
      type: [Array],
      default: () => []
    },
    sensitivityList: {
      type: [Array],
      default: () => []
    },
    sensitivityRowNums: { // 总共可展现数据对: sensitivityRowNums * 2 条
      type: [Number],
      default: 0
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    showHeader: {
      type: [Number, Boolean, String],
      default: false
    }
  },
  data() {
    _id++
    const id = `pump2columnstable_${+new Date()}_${_id}`
    
    return {
      id,
    }
  },
  computed: {
    totalRowNums() {
      const { carboRowNums, sensitivityRowNums, bgRowNums } = this
      return +carboRowNums + +sensitivityRowNums + +bgRowNums
    },
    sensitiveIsLastRow() {
      const { sensitivityRowNums, carboRowNums, bgRowNums } = this
      return sensitivityRowNums - 0 > 0
    },
    carboIsLastRow() {
      const { sensitivityRowNums, carboRowNums, bgRowNums } = this
      return sensitivityRowNums <= 0 && carboRowNums > 0
    },
    bgIsLastRow() {
      const { sensitivityRowNums, carboRowNums, bgRowNums } = this
      return sensitivityRowNums <= 0 && carboRowNums <= 0 && bgRowNums > 0
    },
    w() {
      const { ds } = this
      return ds * (760 / 1740)
      // return ds * (1160 / 1740)
    },
    style() {
      const { showMarginRight, zoomRatio, w } = this
      const rst = { zoom: zoomRatio, width: `${w}px` }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    },
    targetBgValueUnit() {
      const { isPolishLanguage, bgList = [] } = this
      if (isPolishLanguage) {
        return ''
      }
      if (bgList && bgList[0] && bgList[0]['unitStr']) {
        return bgList[0]['unitStr']
      } else {
        return ''
      }
    },
    carbohydrateRatioUnit() {
      const { isPolishLanguage, carboList = [] } = this
      if (isPolishLanguage) {
        return ''
      }
      if (carboList && carboList[0] && carboList[0]['unitStr']) {
        return carboList[0]['unitStr']
      } else {
        return ''
      }
    },
    sensitivityUnit() {
      const { isPolishLanguage, sensitivityList = [] } = this
      if (isPolishLanguage) {
        return ''
      }
      if (sensitivityList && sensitivityList[0] && sensitivityList[0]['unitStr']) {
        return sensitivityList[0]['unitStr']
      } else {
        return ''
      }
    }
  },
  mounted() {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      const i = `${rowIndex}`
      if (i === '0') {
        return 'first-row'
      } else if (i === '11') {
        return 'last-row'
      }
      return ''
    },
    tableCellClassName({ row = {}, column = {}}) {
      const { isSum = false } = row
      const { property = '' } = column
      const ps = `${property}`
      if (ps === 'cell11') {
        return 'corner_cell--bright'
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

$rowH: 40px;
.bolusCalculatorSettingTable_ctn {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;
    .bolusCalculatorSettingTable_titleRow {
        @include bBox;
        height: $rowH;
        /* @include heightMiddle($rowH); */
        @include flexRow(flex-start, center);
        .highLowTable-titleRow_content {
            @include bBox;
            width: 40%;
            flex-shrink: 1;
            text-align: center;
        }
    }
    .bolusCalculatorSettingTable_border--right {
        border-right: 1px solid $colorGluMesurementInnerBorder;
    }
    .bolusCalculatorSettingTable_titleRow, .bolusCalculatorSettingTable_descriptionRow {
        @include bBox;
        /* @include heightMiddle($rowH); */
        height: $rowH;
        overflow: hidden;
        min-height: $rowH;
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.bolusCalculatorSettingTable_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.bolusCalculatorSettingTable_titleRow--top {
            text-indent: 20px;
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    .bolusCalculatorSettingTable_descriptionRow {
        @include flexRow;
        .bolusCalculatorSettingTable_descriptionRow--label, .bolusCalculatorSettingTable_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            height: 100%;
            min-height: $rowH;
            width: 25%;
            @include flexColumn(center, center)
        }
        &.bolusCalculatorSettingTable--twoColumn {
            .bolusCalculatorSettingTable_descriptionRow--label {
                width: 20%;
                width: 40%;
                flex-grow: 0;
                flex-shrink: 0;
            }
            .bolusCalculatorSettingTable_descriptionRow--content {
                width: 70%;
                flex-grow: 1;
                flex-shrin: 1;
            }
        }
        .bolusCalculatorSettingTable_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;
            
            &.bolusCalculatorSettingTable_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.bolusCalculatorSettingTable_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
        
        &.bolusCalculatorSettingTable_descriptionRow--columns {
            align-items: stretch;
            height: auto;
            .bolusCalculatorSettingTable_descriptionRow--columnsOneColumn {
                width: 49%;
                flex-grow: 1;
                @include bBox;
                &.bolusCalculatorSettingTable_descriptionRow--rows {
                    @include flexRow(space-between, stretch);
                    .bolusCalculatorSettingTable_descriptionRow--rowsTitle {
                        background-color: $colorGluMesurementLabelBg;
                        width: 40%;
                        width: 40%;
                        flex-grow: 0;
                        flex-shrink: 0;
                        @include flexRow(space-around, center);
                    }
                    .bolusCalculatorSettingTable_descriptionRow--rowsCtn {
                        flex-grow: 1;
                        .bolusCalculatorSettingTable_descriptionRow--rowsCtnOneRow {
                            border-bottom: 1px solid $colorGluMesurementInnerBorder;
                            &:last-child {
                                border-bottom: 0;
                            }
                            height: $rowH;
                            @include bBox;
                            @include flexRow(space-around, center);
                            > div {
                                /* background: red; */
                                flex-grow: 0;
                                &:first-child {
                                    width: calc(100em / 12);
                                }
                                &:last-child {
                                    /* background: blue; */
                                    flex-grow: 1;
                                    text-align: right;
                                    padding-right: 6px;
                                }
                            }
                        }
                    }
                }   
            }
        }
    }
    
    &.isLongLanguage {
        .bolusCalculatorSettingTable_descriptionRow {
            .bolusCalculatorSettingTable_descriptionRow--columnsOneColumn.bolusCalculatorSettingTable_descriptionRow--rows {
                .bolusCalculatorSettingTable_descriptionRow--rowsTitle {
                    width: 35%;
                    width: 40%;
                }
            }
            &.bolusCalculatorSettingTable--twoColumn {
                .bolusCalculatorSettingTable_descriptionRow--label {
                    /* width: 17.5%; */
                }
                .bolusCalculatorSettingTable_descriptionRow--content {
                    /* width: 82.5%; */
                }
            }
        }
    }
}
</style>
